import { Component } from "react";

export interface Props {
    percent: string;
    languageName: Record<string, string>;
    languageDesc: Record<string, string>;
    lang: string;
};

export default class LanguageRow extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }
    render() {
        // Mapper les drapeaux selon la langue
        const languageName = this.props.languageName[this.props.lang];
        let flag = '';

        if (languageName === 'Français' || languageName === 'French' || languageName === 'Francés') {
            flag = '🇫🇷';
        } else if (languageName === 'Catalan' || languageName === 'Catalán') {
            flag = '🇦🇩';
        } else if (languageName === 'Español' || languageName === 'Spanish' || languageName === 'Espagnol') {
            flag = '🇪🇸';
        } else if (languageName === 'English' || languageName === 'Anglais' || languageName === 'Inglés') {
            flag = '🇬🇧';
        }

        return (
            <div className="mb-3 language-item">
                <div className="language-name">
                    <span className="language-flag">{flag}</span>
                    {this.props.languageName[this.props.lang]}
                    <span className="info-icon">
                        <i className="fas fa-info-circle"></i>
                        <span className="tooltip-text">{this.props.languageDesc[this.props.lang]}</span>
                    </span>
                </div>
                <div className="modern-progress">
                    <div className="progress-fill" style={{width: this.props.percent}}></div>
                </div>
            </div>
        );
    }
}

